import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer-primary',
  imports: [RouterLink],
  template: `
    <footer class="footer mt-auto py-3 bg-body">
      <div class="container text-center">
        <div class="d-flex justify-content-between flex-column flex-md-row">
          <div class="d-flex flex-column flex-md-row gap-md-4">
            <a
              class="text-body-secondary text-decoration-none"
              routerLink="/terminos-y-condiciones"
            >
              Términos y condiciones
            </a>

            <a
              class="text-body-secondary text-decoration-none"
              routerLink="/aviso-de-privacidad"
            >
              Aviso de privacidad
            </a>

            <a
              class="text-body-secondary text-decoration-none"
              routerLink="/finanzas"
            >
              Información financiera
            </a>

            <a
              class="text-body-secondary text-decoration-none"
              routerLink="/documentos-de-referencia"
            >
              Documentos de Referencia
            </a>

            <a
              class="text-body-secondary text-decoration-none"
              routerLink="/comites"
            >
              Comités
            </a>
          </div>

          <span class="text-body-tertiary">
            Todos los derechos reservados &copy; UDEP 2026
          </span>
        </div>
      </div>
    </footer>
  `,
  styles: ``
})
export class FooterPrimaryComponent {}
